module.exports = __webpack_public_path__ + "static/media/x2_icon.31617b5b.svg";